export default {"src":"/_next/static/media/instagram-fill.ef653c29.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};